import { IPolicy, Policy } from "./policy";

export interface IUserPolicy extends IPolicy {
    readonly userId: number;
}

export class UserPolicy extends Policy implements IUserPolicy {
    userId: number;

    constructor(init?: Partial<UserPolicy>) {
        super();
        Object.assign(this, init);
    }

    getRelatedId(): number {
        return this.userId;
    }

    static isUserPolicy(obj: object): obj is IUserPolicy {
        return (
            obj.hasOwnProperty("userId") && typeof (obj as IUserPolicy | Record<string, unknown>).userId === "number"
        );
    }
}
